// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-title[data-v-b9cdac10] {\n  height: 50px;\n}\n.item-text1[data-v-b9cdac10] {\n  font-weight: bold;\n}\n.el-table[data-v-b9cdac10]::before {\n  left: 0;\n  bottom: 0;\n  /* width: 100%; */\n  height: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
